import LeftLeaf from "../assests/images/left-leaf.avif";
import RightLeaf from "../assests/images/right-leaf.avif";

// The home page's laurel emblem: leaf marks flanking a stat ticker that
// continuously scrolls up through the highlights (first slide duplicated so
// the loop wraps seamlessly). Shared by the home hero area and the
// comparison page.
const STATS = [
  { big: "4.9", small: "App Store Rating" },
  { big: "1,000+", small: "User Reviews" },
  { big: "15+", small: "Document Types" },
  { big: "24/7", small: "Live Chat Support" },
];

export default function LaurelStats({ className = "" }) {
  return (
    <div className={`laurel-stats ${className}`}>
      <img src={LeftLeaf} alt="" aria-hidden="true" className="laurel-img" />
      <div className="laurel-ticker" aria-label="MintSlip highlights">
        <div className="laurel-track">
          {[...STATS, STATS[0]].map((s, i) => (
            <div className="laurel-slide" key={i}>
              <span className="laurel-big">{s.big}</span>
              <span className="laurel-small">{s.small}</span>
            </div>
          ))}
        </div>
      </div>
      <img src={RightLeaf} alt="" aria-hidden="true" className="laurel-img" />

      <style>{`
        .laurel-stats {
          --laurel-slide-h: 130px;
          display: flex; align-items: center; justify-content: center; gap: 0;
        }
        .laurel-img { height: 215px; width: auto; flex-shrink: 0; }
        .laurel-ticker { height: var(--laurel-slide-h); min-width: 215px; overflow: hidden; }
        .laurel-track { display: flex; flex-direction: column; animation: laurelScroll 14s infinite; }
        .laurel-slide {
          height: var(--laurel-slide-h); flex-shrink: 0;
          display: flex; flex-direction: column; align-items: center; justify-content: center;
        }
        .laurel-big {
          font-family: 'Outfit', sans-serif; font-weight: 900;
          font-size: 56px; line-height: 1.05; color: #0f172a;
        }
        .laurel-small { margin-top: 4px; font-size: 17px; color: #475569; }
        @keyframes laurelScroll {
          0%, 21%   { transform: translateY(0); }
          25%, 46%  { transform: translateY(calc(var(--laurel-slide-h) * -1)); }
          50%, 71%  { transform: translateY(calc(var(--laurel-slide-h) * -2)); }
          75%, 96%  { transform: translateY(calc(var(--laurel-slide-h) * -3)); }
          100%      { transform: translateY(calc(var(--laurel-slide-h) * -4)); }
        }
        @media (max-width: 640px) {
          .laurel-stats { --laurel-slide-h: 104px; }
          .laurel-img { height: 155px; }
          .laurel-ticker { min-width: 165px; }
          .laurel-big { font-size: 42px; }
          .laurel-small { font-size: 15px; }
        }
        @media (prefers-reduced-motion: reduce) {
          .laurel-track { animation: none; }
        }
      `}</style>
    </div>
  );
}
